export class Table {
    constructor() {
        this.commonOptions    = {
            hozAlign                : "center",
            headerHozAlign          : "center",
            headerFilter            : true,
            headerFilterPlaceholder : " filter...",
            headerSort              : true,
            layout                  : 'fitDataStretch',
        };
        this.option           = [];
    }

    setOption(columns) {
        return columns.map(ob => {
            return {...this.commonOptions, ...ob}
        });
    }
}
